import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { MENU_OPTIONS } from '../../../layout/Layout/menu-options'
import MenuCard from '../../../layout/Navigation/menu-card'
import { getMenuListSelector } from '../../../selectors'
import { BENEFICIARY_TRANSFER_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next';

const menuDetails = MENU_OPTIONS.filter((ele) => ele.key === 'TRANSFER')[0]?.children
const subMenuDetails = menuDetails.filter((ele) => ele.key === 'ADD')[0]?.children

export default function BeneficiaryOption() {
  const history = useHistory()
  const menuConfig = useSelector(getMenuListSelector)['ADD'] || {}
  const {t} =useTranslation()
  return (
    <LayoutWithAccountCard breadCumKey='ADD_BENE'>
      <div className='heading-style1'>{t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.TITLE)}</div>
      <Row>
      {Object.keys(menuConfig).length>0 && subMenuDetails.map((option, index) => (
          <>
            {menuConfig[option.key] &&
            <MenuCard
              handleMenuCallback={() => history.push(option.link)}
              icon={option.icon}
              name={option.title}
              description={option.desc}
              key={index}
            />
            }
          </>
        ))}
      </Row>

      {/* {BENEFICIARY_OPTION_MENUS.map((option, index) => (
        <div className='biller-card row' key={index} onClick={() => history.push(option.link)}>
          <div className='col-5'>
            <img src={menuDetails.icon} />
          </div>
          <div className='col-7'>
            <h3 className='title'>{option?.title}</h3>
            <p>{option.desc}</p>
          </div>
        </div>
      ))} */}
    </LayoutWithAccountCard>
  )
}
